<template>
  <v-content class="organization page">
    <can I="read" a="Organization">
      <v-container v-if="organization">
        <v-toolbar flat class="transparent">
          <v-breadcrumbs
            class="pl-0"
            :items="[
              { exact: true, text: 'Admin', to: '/dashboard' },
              { exact: true, text: 'Organizations', to: '/organizations' },
              { exact: true, text: $route.params.id, to: `/organizations/${$route.params.id}` },
            ]"
          >
            <v-icon slot="divider">mdi-chevron-right</v-icon>
          </v-breadcrumbs>

          <v-spacer />

          <v-btn
            :disabled="!organization.downloadToken"
            :href="`${$root.$api}/admin/organizations/${$route.params.id}.xlsx?token=${organization.downloadToken}`"
            target="_blank"
            small flat fab
          >
            <v-icon class="green--text text--darken-3">mdi-file-excel-box</v-icon>
          </v-btn>
          <v-btn small flat fab :href="`//leap.ly/organizations/${$route.params.id}`">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
          <v-btn small flat fab @click="refresh">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <CopyButton />
        </v-toolbar>

        <can I="edit" a="Organization">
          <v-dialog persistent max-width="80%" v-model="editing">
            <Edit
              v-if="editing"
              @refresh="refresh"
              @publish="publish"
              @unpublish="unpublish"
              @update="update"
              @cancel="cancel"
            />
          </v-dialog>
        </can>
        <Show @refresh="refresh" @destroy="destroy" @edit="editing = true" />

        <OrganizationLocations />
        <OrganizationPhotos />
        <OrganizationPress />
      </v-container>
    </can>
  </v-content>
</template>

<script>
// Components
import Show from '@/components/organizations/Show'
import Edit from '@/components/organizations/Edit'

import OrganizationLocations from '@/components/organizations/OrganizationLocations'
import OrganizationPhotos from '@/components/organizations/OrganizationPhotos'
import OrganizationPress from '@/components/organizations/OrganizationPress'

// Helpers
import { mapGetters } from 'vuex'

// Vue Component
export default {
  name: 'OrganizationPage',
  components: {
    Show,
    Edit,
    OrganizationLocations,
    OrganizationPhotos,
    OrganizationPress,
  },
  data() {
    return { editing: false }
  },
  created() {
    this.$store.dispatch('admin/organizations/fetch', this.$route.params.id)
  },
  computed: {
    ...mapGetters({
      organization: 'admin/organizations/find',
    }),
  },
  methods: {
    refresh() {
      return this.$store.dispatch('admin/organizations/fetch', this.$route.params.id)
    },
    cancel() {
      this.refresh().then(() => (this.editing = false))
    },
    publish() {
      this.$store
        .dispatch(
          'admin/organizations/update',
          Object.assign({}, this.organization, { publishedAt: this.$date(new Date()) })
        )
        .then(() => this.$store.dispatch('snackbarSuccess', 'Published successfully'))
        .catch(() => this.$store.dispatch('snackbarError', 'Organization not published'))
    },
    unpublish() {
      this.$store
        .dispatch(
          'admin/organizations/update',
          Object.assign({}, this.organization, { publishedAt: null })
        )
        .then(() => this.$store.dispatch('snackbarSuccess', 'Unpublished successfully'))
        .catch(() => this.$store.dispatch('snackbarError', 'Organization could not be unpublished'))
    },
    update() {
      this.$store.dispatch('admin/organizations/update', this.organization)
      .then(() => {
        if (this.organization.errors) {
          this.$store.dispatch('snackbarError', 'There was a problem updating the organization')
        } else {
          this.$store.dispatch('snackbarSuccess', 'Organization was updated successfully')
          this.editing = false
        }
      })
    },
    destroy() {
      this.$store.dispatch('admin/organizations/destroy', this.$route.params.id).then(
        () => {
          // Success
          this.$store.commit('snackbar', {
            text: 'Organization deleted',
            type: 'success',
          })
          this.$router.push('/organizations')
        },
        () => {
          // Failure
          this.$store.commit('snackbar', {
            text: 'There was a problem deleting the organization',
            type: 'error',
          })
        }
      )
    },
  },
}
</script>
